class ProductPanels extends HTMLElement {
  constructor() {
    super();

    this.productPanels = this;
    // get scrollbar width
    const vScrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    // compensate for scrollbar
    if (vScrollbarWidth > 0) {
      const css = `
        .product-panel-footprint--is-open,
        .product-panel-materials--is-open,
        .product-panel-washing--is-open,
        .product-panel-shipping--is-open {
          margin-right: ${vScrollbarWidth}px;
        }
      `;

      //create style element
      const style = document.createElement('style');

      //append to product panels
      this.productPanels.append(style);

      // add css to style element
      style.append(document.createTextNode(css));
    }
  }
}

if (!customElements.get('product-panels')) {
  customElements.define('product-panels', ProductPanels);
}